var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"gst-event-not-available__title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('div',{staticClass:"gst-event-not-available__content"},[_c('p',[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }